import { request } from '@/shared/api/request'

export const getCheckUser = () => {
	return request({ url: `paryz/mio/checkUser`, method: 'get' })
}

export const getById = (externalId) => {
	return request({ url: `paryz/mio/get/${externalId}`, method: 'get' })
}

export const getList = (params) => {
	return request({ url: `paryz/mio/list`, method: 'get', params })
}

export const setCheckRow = ({data, payload}) => {
	return request({ url: `paryz/mio/${payload.externalId}/checkRow`, method: 'post', data: data })
}

export const mioSign = (data) => {
	return request({ url: `paryz/mio/sign`, method: 'post', data })
}

export const mioXml = (externalId) => {
	return request({ url: `paryz/mio/${externalId}/xml`, method: 'post'})
}

export const mioRejectXml = ({payload, data}) => {
	return request({ url: `paryz/mio/${payload.externalId}/rejectXml`, method: 'post', data})
}

export const setMioReport = (params) => {
	return request({ url: `paryz/mio/report/create`, method: 'post', params })
}

export const getMioReport = (params) => {
	return request({ url: `paryz/mio/report/get`, method: 'get', params })
}